"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyActionTypes = void 0;
var SurveyActionTypes;
(function (SurveyActionTypes) {
    SurveyActionTypes["SET_INTERVIEW"] = "SET_INTERVIEW";
    SurveyActionTypes["UPDATE_INTERVIEW"] = "UPDATE_INTERVIEW";
    SurveyActionTypes["ADD_CONSENT"] = "ADD_CONSENT";
    SurveyActionTypes["NAVIGATE"] = "NAVIGATE";
    SurveyActionTypes["INIT_NAVIGATE"] = "INIT_NAVIGATE";
    SurveyActionTypes["SET_REVIEW_DECISIONS"] = "SET_REVIEW_DECISIONS";
})(SurveyActionTypes || (exports.SurveyActionTypes = SurveyActionTypes = {}));
//# sourceMappingURL=types.js.map